const Form052SC = {
    stepName: {
        schoolInfor: "学校信息",
        partA: "甲部：申领辅助人员现金津贴",
        partB: "乙部：认证",
        confirmation: "确认",
    },
    errorMsg: {
        shorter: "空缺职位冻结期不得少于30天",
        laterThanDate: "日期不得晚于或早于本学科学年的8月31日",
    },
    label: {
        statement: "个人信息收集声明",
        read: "本人已阅读，明白及同意上述条款及细则",
        read2: "本人理解申请人和教师需要拥有「智方便+」帐户才能处理申请。",
        ssdo: "高级学校发展主任",
        schoolYear: "学年",
        schoolName: "学校名称",
        schoolCode: "学校代码",
        cashGrant: "申领辅助人员现金津贴",
        vacant: "本校欲暂时冻结核准编制内的",
        applyTitle: "请选择部门",
        approved: "职位，以申领辅助人员现金津贴。",
        postNumber: "申领{{cash}}的空缺职位数目",
        claim: "新申领津贴的职位／修订",
        previousClaim: "不更改先前申领／删除先前申领／更改先前申领",
        previousClaimNumber: "请注明前次申領的申请编号",
        errorPreNum: "前次申領的申请编号",
        fromDate: "空缺职位冻结期由",
        toDate: "空缺职位冻结期至（日／月／年）",
        qualifiedNumber: "合资格月数",
        salary: "月薪",
        subsidy: "强积金供款津贴",
        mpfAttachment: "强积金供款证明资料",
        amount: "{{cash}}金额",
        previousClaimDated: "前次申领表格日期",
        previousClaimAttachment: "随附（前次日期）的申领表格副本",
        declaration: "本人证实—",
        establishment: "{{name}}核准编制",
        vacancy: "{{name}}职位空缺",
        fileReference: "教育局批函档号",
        colon: "；",
        space: "",
        supervisorName: "校监姓名",
        date: "日期",
        contactPerson: "联络人",
        telNo: "电话号码",
        ssdo1: "致：学校所属地区的区域教育服务处【经办人：（",
        ssdo2: "）】",
    },
    sectionOption: {
        School: "学校部",
        Boarding: "宿舍部",
    },
    cashValue: {
        TeacherAssistant: "教师助理",
        Cook: "厨师",
        SchoolBusDriver: "特级司机",
        Watchman: "看守员",
    },
    postValue: {
        TeacherAssistant: "教师助理",
        Cook: "厨师",
        SchoolBusDriver: "校巴司机",
        Watchman: "看守员",
    },
    post1Value: {
        teacherAssistant: "教师助理",
        cook: "厨师",
        specialDriver: "特级司机",
        watchman: "看守员",
    },
    sectionValue: {
        TeacherAssistant: "教师助理现金津贴",
        Cook: "厨师现金津贴",
        SchoolBusDriver: "校巴司机现金津贴",
        Watchman: "看守员现金津贴",
    },
    claimValue: { N: "新申领津贴的职位", R: "修订" },
    previousClaimValue: {
        unchange: "不更改先前申领",
        delete: "删除先前申领",
        change: "更改先前申领",
    },
    salaryValue: {
        pt4: "16565",
        pt7: "20035",
        pt8: "21340",
        pt9: "22725",
    },
    sSDOValue: {
        0: "北区",
        1: "葵青区",
        2: "西贡区",
        3: "东区",
        4: "屯门区",
        5: "九龙城区",
        6: "观塘区",
        7: "南区",
        8: "油尖旺区",
        9: "荃湾区",
        10: "沙田区",
        11: "深水埗区",
        12: "大埔区",
        13: "湾仔区",
        14: "离岛区",
        15: "中西区",
        16: "元朗区",
        17: "黄大仙区",
    },
    note1: [
        {
            text: "1. 计算由起始日直至完结日（首尾两天包括在内）的合资格申领辅助人员现金津贴月数，包含以下3个元素：",
        },
        {
            text: "（i）合资格日数在起始月份的历日总数中所占的比例（如适用）；",
        },
        {
            text: "（ii）完整的历月数（如适用）；以及",
        },
        {
            text: "（iii）合资格日数在完结月份历日总数中所占的比例（如适用）。",
        },
        {
            text: "例如：",
        },
        {
            text: "假设合资格申领辅助人员现金津贴的时期是由2月5日至5月26日，计算合资格月数的方法如下：",
        },
        {
            text: "（i）起始月份的合资格日数为24日（2月5日至2月28日）除以28日（2月份的历日总数）= 0.857个月；",
        },
        {
            text: "（ii) 由3月至4月有两个完整的历月数；",
        },
        {
            text: "（iii）完结月份的合资格日数为26日（5月1日至26）除以31日（5月份的历日总数）= 0.839个月。",
        },
        {
            text: "因此，合资格申领月数应为上述3个元素的总和（计算至3个小数位），即0.857 + 2 + 0.839 = 3.696（个月）。",
        },
    ],
    note2: [
        {
            text: "2. 请填写相关职位的中点薪金金额。相关辅助人员的中点薪金已载列于教育局通告第5／2021号，表列如下：",
        },
        {
            text: "有关各项辅助人员现金津贴的用途及行政安排，请参阅教育局通告第5／2021号。",
        },
    ],
    note2Row: {
        post: "职位",
        salary: "中点薪金",
    },
    note2Cell: {
        teacherAssistant: "教师助理",
        cook: "厨师",
        specialDriver: "特级司机",
        watchman: "看守员",
    },
    note2Value: [
        { text: "第一标准薪级表第4点" },
        { text: "总薪级表第7点" },
        { text: "总薪级表第9点" },
        { text: "第一标准薪级表第8点" },
    ],
    note3: "3. 如合资格申领期达60天或以上，强积金计划雇主供款（月薪的5%，并以现行强积金规例所订的最高金额为上限）将会包括在内，金额以四舍五入计算至2个小数位。如换取现金津贴的辅助人员职位空缺冻结期少于60天，而须向强积金供款，请提供证明资料。",
    note4: "4. 每次金额的计算均以四舍五入至2个小数位。",
    note5: "不得少于30天",
    lableStep: [
        { step: "（i）" },
        { step: "（ii）" },
        { step: "（iii）" },
        { step: "（iv）" },
        { step: "（v）" },
    ],
    certify: {
        note1: "本校的法团校董会及大多数",
        note2: "已同意于上述学年期间冻结上述职位；",
        note3: "冻结甲部所载的",
        note4: "的职位并申领辅助人员现金津贴，是因为该（等）核准编制的职位在上述期间有空缺及此项申领符合津贴所列明的申领条件；",
        note5: "申領辅助人员现金津贴的冻结职位于上述期间并无超逾本校的该（等）核准编制（教育局批函档案 :",
        note6: "",
        note7: "）。本校有上述辅助人员职位的空缺（",
        note8: "），在冻结有关人员职位时，空缺的数目会被抵销；",
        note9: "本校没有就上述甲部的职位空缺向政府申领其他津贴；以及",
        note10: "本人明白上述辅助人员现金津贴的安排，让学校在人事聘任上更富弹性，以配合学校的运作和学生的需要。",
        note11: "本人确认本表格所载的资料均正确无误。",
        note12: "本校会把任何多收取的津贴退还教育局。",
    },
};
export default Form052SC;
